module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-11.d0f99dc5.jpg";